import moment from "moment";
import { TIMEZONE_OFFSET } from "./constants";

export const convertToSouthAfricaTime = (
  utcDateString,
  format = "YYYY-MM-DD HH:mm:ss",
) => {
  const utcDate = moment.utc(utcDateString);
  const saDate = utcDate.utcOffset(TIMEZONE_OFFSET);
  return saDate.format(format);
};

export const convertToSouthAfricaDate = (
  utcDateString,
  format = "YYYY-MM-DD",
) => {
  const utcDate = moment.utc(utcDateString);
  const saDate = utcDate.utcOffset(TIMEZONE_OFFSET);
  return saDate.format(format);
};

export const getFormattedUrl = (url) => {
  if (!url) return "";

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  const isLocalUrl = /^(localhost|127(?:\.\d+){3})(:\d+)?(?:\/|$)/i.test(url);

  return `${isLocalUrl ? "http" : "https"}://${url}`;
};
